// extracted by mini-css-extract-plugin
export default {"loading-button":"LoadingButton_loading-button__LVGke"};